<fieldset
  class="group"
  role="group"
  [attr.aria-required]="hasRequiredValidator() ? 'true' : null"
  [attr.aria-invalid]="showError() ? 'true' : null"
>
  <label class="label" [class.required]="hasRequiredValidator()">
    {{ groupLabel() | translate }}
  </label>

  <div class="items d-flex flex-row flex-wrap gap-3">
    @for (item of items(); track item.id; let i = $index) {
      <app-validated-checkbox
        [inputFormControl]="formArray().at(i)"
        [inputFormControlName]="controlNamePrefix() + i"
        [label]="translateItems() ? (item.label | translate) : item.label"
        [leaveSpaceForValidation]="false"
        [dense]="true"
      />
    }
  </div>

  @if (showError()) {
    <div class="feedback">
      @if (errorKeys().length > 0) {
        {{ getErrorMessage(errorKeys()[0]) | translate }}
      }
    </div>
  } @else if (leaveSpaceForValidation()) {
    <div class="placeholder-feedback"></div>
  }
</fieldset>
